// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./ReactClient/src/components/Shared/Layout/Layout/Layout.tsx");
